import { inject, observer } from "mobx-react";
import React, { Component } from "react";
import WindowedSelect from "react-windowed-select";
import AgGrid from "../../../common/components/ag-grid/ag-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport, faSync } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import momenttimezone from 'moment-timezone';
import RestEndPoint from '../../../common/RestEndPoint';
import { AppConstants } from '../../../common/APIConstants';
import WeekPicker from '../../../common/components/week-picker/week-picker';
import _ from 'lodash';
import { exportGridToExcel } from '../export/export';

import './plm-alarm.scss';

@inject("PLMAlarmDataStore")
@observer
class PLMAlarmWeekly extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gridOptionsSeg: {
                singleClickEdit: true,
                suppressScrollOnNewData: true, suppressContextMenu: true,
                defaultColDef: {
                    autoHeight: true, resizable: true, wrapHeaderText: true,
                    autoHeaderHeight: true, suppressMovable: true
                },
            },
            gridOptionsStn: {
                singleClickEdit: true,
                suppressScrollOnNewData: true, suppressContextMenu: true,
                defaultColDef: {
                    autoHeight: true, resizable: true, wrapHeaderText: true,
                    autoHeaderHeight: true, suppressMovable: true
                },
            },
            isDirty: false,
            currentUser: RestEndPoint.getCurrentUserName(),
            ccData: [
                { label: 'Select Control Centre', value: '' },
                { label: 'Midland Control Centre', value: 'Midland' },
                { label: 'Olds Control Centre', value: 'Olds' }
            ],
            ccSelected: { label: 'Select Control Centre', value: '' },
            weekSelected: '',
            screen: _.cloneDeep(this.getCurrentScreen()),
        };
    }
    componentDidMount = async () => {
        const { PLMAlarmDataStore } = this.props
        await PLMAlarmDataStore.getUserRole()
        const params = (
            typeof window.location.hash.split('/')[3] == 'undefined' ?
                null : atob(window.location.hash.split('/')[3]).split('|'));
        if (typeof params != 'undefined' && params != null) {
            try {
                let ccSelected = this.state.ccData.filter(x =>
                    x.value.toLowerCase().includes(params[0]))[0]
                let weekSelected = new Date(moment(params[1], 'DDMMYY'))
                this.setState(
                    { ccSelected: ccSelected, weekSelected: weekSelected },
                    () => this.getGridData()
                );
            } catch (e) {
                this.getGridData()
            }
        } else {
            await this.getGridData()
        }
    };
    getCurrentScreen = () => {
        const screenName = this.props.path.split('/').pop();
        const currentScreen = this.props.CommonStore.screenDetails.find(
            (x) => x.screen.name === screenName
        );
        return currentScreen;
    };
    getGridData = async () => {
        const { CommonStore, PLMAlarmDataStore } = this.props;
        const { screen, ccSelected, weekSelected, gridOptionsSeg, gridOptionsStn } = this.state;

        if (ccSelected?.value && weekSelected) {
            screen.screenFilters = [
                { name: "ControlCentre", value: ccSelected.value },
                { name: "WeekStart", value: `${moment(weekSelected).format("yyyy-MM-DD")} 07:00:00.000` }
            ];
            try {
                CommonStore.toggleLoader();
                await PLMAlarmDataStore.getGridData(screen, weekSelected)
                CommonStore.toggleLoader();
            } catch (error) {
                CommonStore.toggleLoader();
            }
            gridOptionsSeg.api.setColumnDefs(PLMAlarmDataStore.segColDef);
            gridOptionsStn.api.setColumnDefs(PLMAlarmDataStore.stnColDef);
        }
    };
    onCellValueChanged = async (e) => {
        var oldVal = e?.oldValue || null;
        var newVal = e?.newValue || null;
        if ((newVal != oldVal) && (!this.state.isDirty)) {
            this.setState({ isDirty: true });
        }
    }

    onCellEditingStopped = async (e) => {
        const { PLMAlarmDataStore } = this.props
        const { currentUser, isDirty } = this.state;
        if (isDirty) {
            const currentMT = new Date().toLocaleString('en-US', {
                timeZone: AppConstants.MT_TIME_FORMATTER
            })
            const currentScreen = this.getCurrentScreen();
            const editedData = Object.assign({}, e.data);
            editedData.UpdatedBy = currentUser
            editedData.UpdatedOn = currentMT
            await PLMAlarmDataStore.saveRowData(currentScreen, editedData);
            this.setState({ isDirty: false }, () => this.getGridData());
        }
    }
    handleCCSelect = (ccOption) => {
        this.setState({ ccSelected: ccOption }, () => this.getGridData());
    }
    setSelectedWeek = (data) => {
        this.setState({ weekSelected: new Date(data) }, () => this.getGridData());
    }
    getWeek = () => {
        const { weekSelected } = this.state
        if (weekSelected !== '')
            return `Start: ${moment(new Date(weekSelected)).format('MM/DD/yyyy')}
         07:00:00 MT — End:  ${moment(new Date(weekSelected)).add(7, 'd').format('MM/DD/yyyy')}
         07:00:00 MT`
        return null
    }

    exportToExcel = () => {
        const { rowDataSeg, rowDataStn } = this.props.PLMAlarmDataStore
        const { ccSelected, weekSelected } = this.state
        exportGridToExcel(rowDataSeg, rowDataStn, ccSelected, weekSelected)
    }

    render() {
        const { rowDataStn, rowDataSeg, segColDef, stnColDef } = this.props.PLMAlarmDataStore
        const {
            gridOptionsSeg,
            gridOptionsStn,
            ccData, ccSelected,
            weekSelected
        } = this.state;

        Array.from(document.getElementsByClassName('ag-fresh')).forEach(e => {
            if (!e.className.includes('plm-grid-container')) e.className += ' plm-grid-container'
        });
        Array.from(document.getElementsByClassName('ag-theme-balham grid-container')).forEach(e => {
            if (!e.className.includes('plm-grid-container')) e.className += ' plm-grid-container'
        });
        return (
            <>
                <div className="plm-row-justify">
                    <h3 className="plm-title">PLM Alarms - Weekly Report</h3>
                    <div className="plm-slicer-container">
                        <span className="plm-div-style">Control Centre</span>
                        <span className="plm-mandatory">&nbsp;*</span>
                        <span className="plm-select">
                            <WindowedSelect
                                options={ccData}
                                onChange={this.handleCCSelect}
                                value={ccSelected}
                            />
                        </span>
                    </div>
                    {
                        ccSelected?.value ?
                            <div className="plm-slicer-container">
                                <span className="plm-div-style">Week</span>
                                <span className="plm-mandatory">&nbsp;*</span>
                                <span className="plm-select">
                                    <WeekPicker
                                        setSelectedWeek={this.setSelectedWeek}
                                        defaultDate={weekSelected}
                                        minDate={momenttimezone.tz(moment(moment.utc(new Date(
                                            '2023-11-27')).format('YYYY-MM-DDT00:00:00')),
                                            AppConstants.MT_TIME_FORMATTER)
                                        }
                                    />
                                </span>
                            </div>
                            : null
                    }
                    {ccSelected?.value && weekSelected ?
                        <>
                            <button
                                type="button"
                                className="btn btn-primary plm-btn"
                                aria-expanded="false"
                                onClick={this.getGridData}
                            >
                                <FontAwesomeIcon icon={faSync} /> Refresh
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary plm-btn"
                                aria-expanded="false"
                                onClick={this.exportToExcel}
                            >
                                <FontAwesomeIcon icon={faFileExport} /> Export
                            </button>
                        </>
                        : null
                    }
                </div>
                {
                    ccSelected?.value && weekSelected ?
                        <>
                            <div className='plm-row container-first-grid'>
                                <AgGrid
                                    gridOptions={gridOptionsSeg}
                                    columnDefs={segColDef}
                                    rowData={rowDataSeg}
                                    onCellValueChanged={this.onCellValueChanged.bind(this)}
                                    onCellEditingStopped={this.onCellEditingStopped.bind(this)}
                                />
                            </div>
                            <div className='plm-row'>
                                <AgGrid
                                    gridOptions={gridOptionsStn}
                                    columnDefs={stnColDef}
                                    rowData={rowDataStn}
                                    onCellValueChanged={this.onCellValueChanged.bind(this)}
                                    onCellEditingStopped={this.onCellEditingStopped.bind(this)}
                                />
                            </div>
                        </> : null
                }
            </>
        )
    }
}
export default PLMAlarmWeekly;